import { Mask } from './styles';

export function FaceFocus() {
  return <Mask />;
}
